import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { SelectMitarbeiterPage } from './select-mitarbeiter';

@NgModule({
  declarations: [
    SelectMitarbeiterPage,
  ],
  imports: [
    IonicPageModule.forChild(SelectMitarbeiterPage),
  ],
})
export class SelectMitarbeiterPageModule {}



// WEBPACK FOOTER //
// ./src/pages/select-mitarbeiter/select-mitarbeiter.module.ts